import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';

const PublicTest = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Card>
        <CardContent>
          <Typography variant="h4" gutterBottom>
            Public Route Test
          </Typography>
          <Typography variant="body1">
            Jika Anda melihat halaman ini, berarti public routing berfungsi dengan baik!
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default PublicTest;

